<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/overlays';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-aria/overlays/package.json';

---
category: Overlays
keywords: [dialog, modal, tray, popover, aria]
---

# DismissButton

<p>{docs.exports.DismissButton.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['DismissButton']} />

## Introduction

`DismissButton` is a visually hidden button that can be used by screen reader users to close an overlay
in the absence of a visual dismiss button. This may typically be used with a menu or a popover since they often
forgo a visual dismiss button, instead allowing users to use the <kbd>Escape</kbd> key to dismiss the menu or popover.

## Props

<PropTable links={docs.links} component={docs.exports.DismissButton} />

## Example

See [useMenuTrigger](useMenuTrigger.html#example) and [useOverlayTrigger](useOverlayTrigger.html#example)
for examples of how to use `DismissButton` with a menu or popover.
